module.exports = "<div appInitTheme class=\"container\">\n  <div class=\"d-flex\">\n    <div class=\"container-fluid p-0 over\">\n      <div class=\"mb-4\">\n        <app-market-banner></app-market-banner>\n      </div>\n      <div class=\"card\">\n        <div class=\"card-body\">\n          <router-outlet name=\"dashboard-content\"></router-outlet>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/dashboard/dashboard.component.html
// module id = ../../../../../src/app/dashboard/dashboard.component.html
// module chunks = main